<template>

    <el-dialog
      title="Добавление нового сотрудника"
      :visible="visible"
      :before-close="close"
      @opened="onOpen"
    >
    <el-form ref="addForm" :rules="addFormRules" :model="addForm" v-loading="loading">
      <el-form-item label="Фамилия" prop="surname"  :error="errors.surname | errorToSrt">
        <el-input name="surname" ref="autoFocus" placeholder="Введите фамилию" v-model="addForm.surname"></el-input>
      </el-form-item>
      <el-form-item label="Имя" prop="name" :error="errors.name | errorToSrt">
      <el-input name="name" placeholder="Введите имя" v-model="addForm.name"></el-input>
    </el-form-item>
      <el-form-item label="Отчество" prop="patronymic" :error="errors.patronymic | errorToSrt">
      <el-input name="patronymic" placeholder="Введите отчество" v-model="addForm.patronymic"></el-input>
    </el-form-item>
      <el-form-item label="Телефон" prop="phone" :error="errors.phone | errorToSrt">
        <el-input v-mask="'+7-###-###-##-##'"
                  placeholder="+7-xxx-xxx-xx-xx"
                  auto-complete="off"
                  name="phone"
                  v-model="addForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="E-mail" prop="email" :error="errors.email | errorToSrt">
        <el-input name="email" placeholder="Введите email адрес" v-model="addForm.email"></el-input>
      </el-form-item>
      <el-form-item label="Дата роджения" prop="birthday" :error="errors.birthday | errorToSrt">
        <el-date-picker
          v-model="addForm.birthday"
          type="date"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          class="dialog__date"
          placeholder="Укажите дату рождения">
        </el-date-picker>
      </el-form-item>

      <el-form-item prop="gender_id" label="Пол" :error="errors.gender_id | errorToSrt">
        <el-select
          class="dialog__select"
          v-model="addForm.gender_id"
          placeholder="Укажите пол"
        >
          <el-option
            v-for="gender in genderList"
            :key="gender.id"
            :label="gender.title"
            :value="gender.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Пароль" prop="password" :error="errors.password | errorToSrt">
        <el-input name="password" placeholder="Введите пароль" ref="password" show-password v-model="addForm.password">
          <el-tooltip content="Создать надежный пароль" slot="append" ><el-button @click="generatePassword" icon="el-icon-magic-stick"></el-button></el-tooltip>
        </el-input>
      </el-form-item>

<!--      <el-form-item label="Роль сотрудника" prop="type">-->
<!--        <el-select v-model="addForm.type" class="dialog__select">-->
<!--          <el-option value="20" label="Ассистент" />-->
<!--          <el-option value="40" label="Врач" />-->
<!--          <el-option value="60" label="Администратор" />-->
<!--        </el-select>-->
<!--      </el-form-item>-->

      <el-form-item label="Какие экраны видит пользователь:">

      <el-form-item>
        <div>
          <el-checkbox-group v-if="addForm.features" v-model="addForm.features" class="dialog__select">
            <el-checkbox-button v-for="feature in featuresList" :label="feature.value" :value="feature.value" :key="feature.value">
              {{ feature.title }}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
      </el-form-item>
      </el-form-item>

    </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          name="create"
          type="default"
          :loading="loadAddForm"
          @click="saveForm(false)"
        >Сохранить и создать нового сотрудника</el-button>
        <el-button
          type="primary"
          :loading="loadAddForm"
          @click="saveForm(true)"
        >Сохранить и закрыть</el-button>
      </span>
    </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'
Vue.use(VueMask)

export default {
  name: 'DialogWorkerAdd',
  data () {
    return {
      form: null,
      error: null,
      loadAddForm: !!0,
      genderList: null,
      loading: !!1,
      errors: {},
      addForm: {
        type: '20',
        features: []
      },
      featuresList: [
        {
          title: 'Список визитов',
          value: 'doctor_inspection'
        },
        {
          title: 'Прием',
          value: 'screening_plus'
        },
        {
          title: 'Бронирование',
          value: 'appointment'
        },
        {
          title: 'Клиенты',
          value: 'users'
        },
        {
          title: 'Сервисное меню',
          value: 'service_menu'
        },
        {
          title: 'Комплексы упражнений',
          value: 'complex_exercises'
        }
      ],
      addFormRules: {
        surname: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        phone: [
          { required: false, message: 'Заполните поле', trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, message: 'Заполните поле', trigger: 'blur' },
          { type: 'email', message: 'Укажите валидный e-mail', trigger: ['blur', 'change'] }
        ],
        gender_id: [
          { required: true, message: 'Укажите пол', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите роль', trigger: 'blur' }]
      }
    }
  },

  filters: {
    errorToSrt (t) {
      return t ? t.join(', ') : null
    }
  },
  props: {
    visible: {
      required: true
    }
  },
  methods: {
    onOpen () {
      this.loadLogic()
    },
    close () {
      this.$emit('close')
    },
    loadLogic () {
      // this.addForm = {
      //   type: '20'
      // }
      this.autoFocus()

      this.loading = !!1
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.loading = !!0
        })
    },
    generatePassword () {
      Vue.set(this.addForm, 'password', Math.random().toString(36).slice(-8))
      this.$refs.password.passwordVisible = !!1
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.errors = {}
          this.loadAddForm = !!1
          const payLoad = { ...this.addForm, ...{} }
          payLoad.phone = payLoad.phone ? payLoad.phone.replace(/[^\d]/g, '') : ''

          this.$api.doctor
            .create(payLoad)
            .then((response) => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })

              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                // this.addForm = {
                //   type: '20'
                // }
                this.autoFocus()
              }
            })
            .catch((response) => {
              const attribute = response.response.data.attribute
              if (attribute) { this.errors = attribute }

              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message ? response.response.data.message : 'Проверьте правильность полей'
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__date {
    margin: 10px 0;
    width: 100%;
  }

  &__btns {
    float: right;
  }
}

</style>
